var _defs, _g, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighlight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-3{clip-path:url(#clippath);}.cls-4{fill:#fff;}.cls-5{fill:#c1d2e4;}.cls-6{fill:url(#linear-gradient);fill-opacity:.5;}.cls-2{stroke:#fff;stroke-miterlimit:10;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 3,
    ry: 3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 19.12,
    y1: 19.12,
    x2: 4.88,
    y2: 4.88,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4520e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fccc00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#afc219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00ac53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7693fb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 4,
    y: 12,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 8,
    y: 12,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 12,
    y: 12,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 16,
    y: 12,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 16,
    y: 16,
    width: 4,
    height: 4,
    transform: "translate(36 36) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 12,
    y: 16,
    width: 4,
    height: 4,
    transform: "translate(28 36) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 8,
    y: 16,
    width: 4,
    height: 4,
    transform: "translate(20 36) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 4,
    y: 16,
    width: 4,
    height: 4,
    transform: "translate(12 36) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 4,
    y: 4,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 8,
    y: 4,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 12,
    y: 4,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 16,
    y: 4,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 16,
    y: 8,
    width: 4,
    height: 4,
    transform: "translate(36 20) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 12,
    y: 8,
    width: 4,
    height: 4,
    transform: "translate(28 20) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 8,
    y: 8,
    width: 4,
    height: 4,
    transform: "translate(20 20) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 4,
    y: 8,
    width: 4,
    height: 4,
    transform: "translate(12 20) rotate(-180)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 3,
    ry: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 3,
    ry: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlight);
export default __webpack_public_path__ + "static/media/highlight.515d809435b99f2bd1f52caab912ab93.svg";
export { ForwardRef as ReactComponent };